import { render, staticRenderFns } from "./EditEventView.vue?vue&type=template&id=53cb66ec&"
import script from "./EditEventView.vue?vue&type=script&lang=js&"
export * from "./EditEventView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports